import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { white } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flex: 1,
		overflow: 'hidden',
		backgroundColor: white,
	},
	verticalTabList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		padding: THEME.spacing.md,
		borderRight: `1px solid ${THEME.colors.border.light}`,
		width: '200px',
		flexShrink: 0,
		backgroundColor: THEME.colors.background.light,
		overflowY: 'auto',
	},
	tabTrigger: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		border: 'none',
		borderRadius: THEME.common.borderRadius,
		backgroundColor: 'transparent',
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.standard,
		cursor: 'pointer',
		transition: 'all 0.2s',
		textAlign: 'left',
		textDecoration: 'none',
		':hover': {
			backgroundColor: THEME.colors.hover.light,
		},
	},
	tabTriggerActive: {
		backgroundColor: THEME.colors.primary.light,
		color: THEME.colors.primary.main,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	contentArea: {
		flex: 1,
		overflow: 'auto',
		padding: THEME.spacing.lg,
	},
	placeholderContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.lg,
	},
	content: {
		minWidth: 1118,
	},
});
